var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72222 4.6875H0.277778C0.124365 4.6875 0 4.81187 0 4.96528V5.03472C0 5.18813 0.124365 5.3125 0.277778 5.3125H9.72222C9.87564 5.3125 10 5.18813 10 5.03472V4.96528C10 4.81187 9.87564 4.6875 9.72222 4.6875Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01853 9.43591L2.74788 7.16527C2.65728 7.07467 2.65728 6.92736 2.74788 6.83676L3.08078 6.50387C3.17138 6.41326 3.31869 6.41326 3.40929 6.50387L4.85456 7.94914C4.94517 8.03974 5.09247 8.03974 5.18307 7.94914L6.62835 6.50387C6.71895 6.41326 6.86625 6.41326 6.95686 6.50387L7.28975 6.83676C7.38036 6.92736 7.38036 7.07467 7.28975 7.16527L5.01911 9.43591H5.01853Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62835 2.93205L5.01882 1.32252L3.40929 2.93205C3.31869 3.02265 3.17138 3.02265 3.08078 2.93205L2.74788 2.59915C2.65728 2.50855 2.65728 2.36125 2.74788 2.27064L5.01882 0L7.28946 2.27064C7.38006 2.36125 7.38006 2.50855 7.28946 2.59915L6.95656 2.93205C6.86596 3.02265 6.71866 3.02265 6.62805 2.93205H6.62835Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenAllIcon);
export default __webpack_public_path__ + "static/media/OpenAllIcon.e4a1e01a88682c9031a2ad81dcfaad9d.svg";
export { ForwardRef as ReactComponent };